<template>
  <div class="ap-buyer-index">
    <div class="clearfix acc-info" style="overflow: hidden;">
      <div class="float-left account" style="height:72px;">
        <img src="@/assets/icons/user.png" style="float:left;" />
        <div style="float:left;margin-left:10px;">
          <div>
            <strong>{{userDetail.name}}</strong>
          </div>
          <div>
            <strong>{{userDetail.userPrincipals[0].principal}}</strong>
          </div>
        </div>
      </div>
      <div class="float-left corp">
        <strong>{{userDetail.orgName}}</strong>
        <div class="font12">暂无信用等级</div>
      </div>
    </div>
    <div class="item">
      <div class="title">系统通知</div>
      <div class="content">
        <div class="left">
          <img src="@assets/icons/beizi.png" />
        </div>
        <div class="right">
          <div class="top">采购商信息已提交，正在审核中（1-2工作日）。</div>
          <div class="center">审核结果将自动以短信通知到您的注册手机，敬请留意。</div>
          <div class="botton">联系平台客服</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userDetail: {}
    };
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    getUserDetail() {
      this.$get("/spms/myProfiles/getProfile", {}, { noFailureMsg: true })
        .then(res => (this.userDetail = res))
        .catch(err => {});
    }
  }
};
</script>

<style lang="less">
.content {
  display: flex;
  border: 1px solid rgba(204, 204, 204);
  .left {
    width: 150px;
    height: 150px;
    img {
      margin: 43px;
    }
  }
  .right {
    .top {
      margin-top: 20px;
      font-weight: 700;
      font-size: 16px;
      color: #1e1e1e;
    }
    .center {
      margin: 10px 0;
      font-size: 12px;
      font-family: "微软雅黑";
      font-weight: 400;
      color: #666666;
    }
    .botton {
      padding: 10px;
      font-weight: 700;
      font-size: 14px;
      color: #ffffff;
      display: inline-block;
      background: #099;
      border-radius: 30px;
    }
  }
}
</style>